import {
  AxiosDeleteToken,
  AxiosGet,
  AxiosGetToken,
  AxiosPostFormDataToken,
  AxiosPostToken,
  AxiosPutToken,
} from "./AxiosCall";

export const getProductApi = async ({
  page,
  limit,
  search,
  start_date,
  end_date,
}) => {
  try {
    let res = await AxiosGet("product", {
      page,
      limit,
      search,
      order: "DESC",
      start_date,
      end_date,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getProductDetailApi = async ({ product_id }) => {
  try {
    let res = await AxiosGet("product/by", {
      product_id: product_id,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteProductApi = async ({ product_id }) => {
  try {
    let res = await AxiosDeleteToken("product/" + product_id);
    return res;
  } catch (error) {
    return error;
  }
};

export const getCircularDetailApi = async ({ product_id }) => {
  try {
    let res = await AxiosGetToken("circular", {
      products_id: product_id,
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const getProductTypeApi = async () => {
  try {
    let res = await AxiosGetToken("product/type");
    return res;
  } catch (error) {
    return error;
  }
};

export const getProductUnitApi = async () => {
  try {
    let res = await AxiosGetToken("product/unit");
    return res;
  } catch (error) {
    return error;
  }
};
export const createCircularDesignApi = async ({
  products_id,
  name,
  phone,
  establishment,
  province,
  economy_label_check,
  economy_label,
  fiber_type_check,
  fiber_type,
  generalization_check,
  generalization,
  certification_doc_check,
  certification_doc,
  ph_check,
  size_change_check,
  wash_durability_check,
  sweat_durability_check,
  production_steps,
  processing_steps,
  cer_date,
  exp_date,
}) => {
  try {
    let res = await AxiosPostToken("circular", {
      products_id,
      name,
      phone,
      establishment,
      province,
      economy_label_check,
      economy_label,
      fiber_type_check,
      fiber_type,
      generalization_check,
      generalization,
      certification_doc_check,
      certification_doc,
      ph_check,
      size_change_check,
      wash_durability_check,
      sweat_durability_check,
      production_steps,
      processing_steps,
      cer_date,
      exp_date,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateCircularDesignApi = async ({
  products_id,
  name,
  phone,
  establishment,
  province,
  economy_label_check,
  economy_label,
  fiber_type_check,
  fiber_type,
  generalization_check,
  generalization,
  certification_doc_check,
  certification_doc,
  ph_check,
  size_change_check,
  wash_durability_check,
  sweat_durability_check,
  production_steps,
  processing_steps,
  tag_check,
  cer_date,
  exp_date,
}) => {
  try {
    let res = await AxiosPutToken("circular", {
      products_id,
      name,
      phone,
      establishment,
      province,
      economy_label_check,
      economy_label,
      fiber_type_check,
      fiber_type,
      generalization_check,
      generalization,
      certification_doc_check,
      certification_doc,
      ph_check,
      size_change_check,
      wash_durability_check,
      sweat_durability_check,
      production_steps,
      processing_steps,
      tag_check,
      cer_date,
      exp_date,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const createProductApi = async ({
  name,
  product_types_id,
  no,
  technic,
  pattern,
  material,
  attribute_old,
  width,
  length,
  depth,
  product_units_id,
  old,
  amount,
  price,
  note,
  product_img,
  cer_date,
  exp_date,
}) => {
  let formData = new FormData();
  formData.append("name", name);
  formData.append("product_types_id", product_types_id);
  formData.append("no", no);
  formData.append("technic", technic);
  formData.append("pattern", pattern);
  formData.append("material", material);
  formData.append("attribute_old", attribute_old);
  formData.append("width", width);
  formData.append("length", length);
  formData.append("depth", depth);
  formData.append("product_units_id", product_units_id);
  formData.append("old", old);
  formData.append("amount", amount);
  formData.append("price", price);
  formData.append("note", note);
  formData.append("product_img", product_img);
  formData.append("cer_date", cer_date);
  formData.append("exp_date", exp_date);
  try {
    let res = await AxiosPostFormDataToken("product", formData);
    return res;
  } catch (error) {
    return error;
  }
};

export const editProductApi = async ({
  id,
  name,
  product_types_id,
  no,
  technic,
  pattern,
  material,
  attribute_old,
  width,
  length,
  depth,
  product_units_id,
  old,
  amount,
  price,
  note,
  product_img,
  cer_date,
  exp_date,
}) => {
  let formData = new FormData();
  formData.append("product_id", id);
  formData.append("name", name);
  formData.append("product_types_id", product_types_id);
  formData.append("no", no);
  formData.append("technic", technic);
  formData.append("pattern", pattern);
  formData.append("material", material);
  formData.append("attribute_old", attribute_old);
  formData.append("width", width);
  formData.append("length", length);
  formData.append("depth", depth);
  formData.append("product_units_id", product_units_id);
  formData.append("old", old);
  formData.append("amount", amount);
  formData.append("price", price);
  formData.append("note", note);
  formData.append("product_img", product_img);
  formData.append("cer_date", cer_date);
  formData.append("exp_date", exp_date);

  try {
    let res = await AxiosPostFormDataToken("product/" + id, formData);
    return res;
  } catch (error) {
    return error;
  }
};
